
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.063 12.531a.555.555 0 00-.407.172.556.556 0 00-.172.406v2.579H13.11h-.015a.555.555 0 00-.406.171.523.523 0 00-.172.407c0 .156.057.291.171.406.115.114.25.172.407.172H14.313V26.89c0 .156.057.291.171.406a.573.573 0 00.422.172h10.328a.555.555 0 00.407-.172.555.555 0 00.172-.406V16.844h1.108a.555.555 0 00.407-.172.555.555 0 00.172-.406.523.523 0 00-.172-.407.555.555 0 00-.406-.171h-3.406v-2.579a.556.556 0 00-.172-.406.555.555 0 00-.407-.172h-5.875zm.578 3.156v-2h4.718v2h-4.718zm-2.157 10.626v-9.47h9.172v9.47h-9.172zm3.141-7.047a.427.427 0 00-.188-.11.448.448 0 00-.203-.047.556.556 0 00-.406.172.555.555 0 00-.172.407c0 .072.01.145.032.218.03.063.072.12.125.172l1.359 1.36-1.36 1.359a.622.622 0 00-.156.203.59.59 0 00-.047.234c0 .157.058.292.172.407a.574.574 0 00.422.172.588.588 0 00.235-.047.495.495 0 00.187-.141L20 22.265l1.375 1.36c.052.063.115.11.188.14a.588.588 0 00.234.047.574.574 0 00.422-.171.556.556 0 00.172-.407.464.464 0 00-.063-.234.476.476 0 00-.14-.203l-1.36-1.36 1.36-1.359a.439.439 0 00.109-.172.555.555 0 00-.125-.625.556.556 0 00-.625-.125.44.44 0 00-.172.11L20 20.625l-1.375-1.36z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"1","y":"1","width":"38","height":"38","rx":"3","stroke":"currentColor","stroke-width":"2"}})])
          )
        }
      }
    